import React from "react";
import "react-bootstrap/dist/react-bootstrap.min.js";
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { store } from "../redux/store";
import { Provider } from "react-redux";
import Home from "./Components/Home";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter basename={'/'}>
        <Switch>
          <Route path="*" component={Home} />
        </Switch>
      </BrowserRouter>
    </Provider>
  );
}

export default App;